<style>
.linea-celeste {
  border-top: 1px solid rgb(0, 149, 255);
  width: 100%;
  margin-top: 0.5rem;
  /* Puedes ajustar el margen según tus preferencias */
}
</style>
<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h3 class="form-header">Hola, ¿Qué deseas hacer?</h3>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="col-12 modal-header faded">
          <div class="col-6">
            <a @click="abrirModalLogin((current.abrir = 'habilitar'))"
              class="element-box el-tablo centered trend-in-corner smaller" href="#">
              <div class="value">Habilitar Tarima <i class="fa fa-check-square	
"></i></div>
            </a>
          </div>
          <div class="col-6">
            <a @click="abrirModalLogin((current.abrir = 'anular'))"
              class="element-box el-tablo centered trend-in-corner smaller" href="#">
              <div class="value value-danger">
                Anular Tarima <i class="fa fa-minus-square"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="habilitarModal" tabindex="-1" role="dialog" style="backdrop-filter: blur(10px)"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Habilitar Tarima</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="controls-above-table">
              <div class="row">
                <div class="col-12">
                  <div style="
                      border-left: 95px solid #b4dafe !important;
                      border-right: 95px solid #b4dafe !important;
                      color: #000 !important;
                    " class="alert alert-light text-center" role="alert">
                    <span class="text-dark">
                      <span class="font-weight-bold"> Atención: </span>Solo se puede abrir
                      la tarima con un máximo de 8 dias despues de la fecha de creación de
                      la tarima.
                    </span>
                    <p class="mb-0"></p>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <label>Barra de Tarima</label>
                      <input @change="buscarTarima(current)" v-model="current.barra"
                        v-on:keyup.enter="buscarTarima(current)" class="form-control" type="text" />
                    </div>
                    <div class="col-4">
                      <label>Número de Tarima</label>
                      <input @change="buscarTarima(current)" v-model="current.numero"
                        v-on:keyup.enter="buscarTarima(current)" class="form-control" type="text" />
                    </div>
                    <div class="col-4">
                      <label>Tipo Tarima</label>
                      <select @change="buscarTarima(current)" v-model="current.tipo_traslado" class="form-control"
                        type="date">
                        <option value=""></option>
                        <option value="T">TRASLADO</option>
                        <option value="D">DEVOLUCIÓN</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="alert alert-light" role="alert">
                    <table class="table table-striped table-lightborde text-dark">
                      <thead>
                        <tr>
                          <th class="text-center">#</th>
                          <th class="text-center">barra</th>
                          <th class="text-center">Tienda Origen</th>
                          <th class="text-center">Tienda Destino</th>
                          <th class="text-center">Tipo</th>
                          <th class="text-center">Fecha Creación</th>
                          <th class="text-center">Fecha Recepción</th>
                          <th class="text-center">Estado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in tarimas" v-bind:key="detalle.id">
                          <td class="text-center">{{ detalle.numero }}</td>
                          <td class="text-center">{{ detalle.barra }}</td>

                          <td class="text-center">
                            {{ detalle.tienda_origen_obj.nombre }}
                          </td>
                          <td class="text-center">
                            {{ detalle.tienda_destino_obj.nombre }}
                          </td>
                          <td v-if="detalle.salida_e_objeto" class="text-center">
                            {{ detalle.salida_e_objeto.tipo_traslado_str }}
                          </td>
                          <td class="text-center">
                            {{ detalle.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss") }}
                          </td>
                          <td class="text-center">
                            {{
                              detalle.fecha_recepcion_tarima
                              | moment("DD/MM/YYYY HH:MM:ss")
                            }}
                          </td>
                          <td class="text-center">
                            {{ detalle.estado_str }}
                          </td>
                          <td class="text-center">
                            <div class="btn-group dropleft">
                              <a class="btn btn-sm btn-info dropdown-toggle" href="#" role="button"
                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Opciones
                              </a>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <a class="dropdown-item" @click="abrirTarima(detalle)"
                                  style="background-color: #76caf5">Habilitar Tarima
                                </a>
                                <a @click="select(detalle)" class="dropdown-item"
                                  style="background-color: #9fff8a">Reiniciar Conteo de Tarima
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <br />
                      <button class="btn btn-md btn-outline-dark" ref="cerrarModal" type="button" @click="resetData()">
                        <i class="fas fa-sync-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="anularModal" tabindex="-1" role="dialog" style="backdrop-filter: blur(10px)"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" style="width: 100%; max-width: 100%">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Anular Tarima</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="controls-above-table">
              <div class="row">
                <div class="col-12">
                  <div style="
                      border-left: 95px solid #ecae9b !important;
                      border-right: 95px solid #ecae9b !important;
                      color: #000 !important;
                    " class="alert alert-light text-center" role="alert">
                    <span class="text-dark">
                      <span class="font-weight-bold"> Atención: </span>La tarima solo se
                      puede anular si aún no ha sido finalizada, en caso contrario es obligatoriamente una inconsistencia,
                      esto debido a que genera movimiento en SAP.
                    </span>
                    <p class="mb-0"></p>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      <label>Barra de Tarima</label>
                      <input @change="buscarTarima(current)" v-model="current.barra"
                        v-on:keyup.enter="buscarTarima(current)" class="form-control" type="text" />
                    </div>
                    <div class="col-4">
                      <label>Número de Tarima</label>
                      <input @change="buscarTarima(current)" v-model="current.numero"
                        v-on:keyup.enter="buscarTarima(current)" class="form-control" type="text" />
                    </div>
                    <div class="col-4">
                      <label>Tipo Tarima</label>
                      <select @change="buscarTarima(current)" v-model="current.tipo_traslado" class="form-control"
                        type="date">
                        <option value=""></option>
                        <option value="T">TRASLADO</option>
                        <option value="D">DEVOLUCIÓN</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="alert alert-light" role="alert">
                    <table class="table table-striped table-lightborde text-dark">
                      <thead>
                        <tr>
                          <th class="text-center">#</th>
                          <th class="text-center">barra</th>
                          <th class="text-center">Tienda Origen</th>
                          <th class="text-center">Tienda Destino</th>
                          <th class="text-center">Tipo</th>
                          <th class="text-center">Fecha Creación</th>
                          <th class="text-center">Fecha Recepción</th>
                          <th class="text-center">Estado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in tarimas" v-bind:key="detalle.id">
                          <td class="text-center">{{ detalle.numero }}</td>
                          <td class="text-center">{{ detalle.barra }}</td>

                          <td class="text-center">
                            {{ detalle.tienda_origen_obj.nombre }}
                          </td>
                          <td class="text-center">
                            {{ detalle.tienda_destino_obj.nombre }}
                          </td>
                          <td v-if="detalle.salida_e_objeto" class="text-center">
                            {{ detalle.salida_e_objeto.tipo_traslado_str }}
                          </td>
                          <td class="text-center">
                            {{ detalle.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss") }}
                          </td>
                          <td class="text-center">
                            {{
                              detalle.fecha_recepcion_tarima
                              | moment("DD/MM/YYYY HH:MM:ss")
                            }}
                          </td>
                          <td class="text-center">
                            {{ detalle.estado_str }}
                          </td>
                          <td class="text-center">
                            <div class="btn-group dropleft">
                              <a class="btn btn-sm btn-info dropdown-toggle" href="#" role="button"
                                id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Opciones
                              </a>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                <a @click="anularTarima(detalle)" class="dropdown-item"
                                  style="background-color: #ff7667">Anular tarima
                                </a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <br />
                      <button class="btn btn-md btn-outline-dark" ref="cerrarModal" type="button" @click="resetData()">
                        <i class="fas fa-sync-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="modalproducto" tabindex="1" style="backdrop-filter: blur(10px)" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">¿Qué producto?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <ProductoSelectComponentV2 :current="current" />
              </div>
              <div class="col-md-12">
                <UsuariosSelectComponent titulo="Usuario Solicita Habilitación" :current="current" />
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      errors != null &&
                      errors.observaciones &&
                      errors.observaciones.length > 0,
                  }">Observaciones</label>
                  <textarea class="form-control" rows="3" v-model="current.observaciones" autofocus="autofocus"
                    placeholder="Descripción" v-bind:class="{
                      'is-invalid':
                        errors != null &&
                        errors.observaciones &&
                        errors.observaciones.length > 0,
                    }">
                  </textarea>
                  <small v-if="errors != null && errors.observaciones && errors.observaciones"
                    class="form-text text-danger">{{ errors.observaciones[0] }}</small>
                </div>
              </div>
            </div>
            <div v-if="errors != null" class="col-12">
              <span class="text-danger ont-weight-bold">""{{ errors }}""</span>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="reiniciarConteo()" class="btn btn-success btn-block btn-md">
              Reiniciar conteo
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="login" tabindex="-1" style="backdrop-filter: blur(10px)" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content color-scheme-dark">
          <div class="modal-header">
            <h5 class="modal-title col-12 text-light" id="exampleModalLabel">
              Login <i class="fas fa-lock"></i>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <hr class="linea-celeste" />
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 row">
                <div class="col-1"><i class="fas fa-user fa-2x"></i></div>
                <div class="col-11">
                  <input class="form-control" placeholder="Usuario" v-model="current_log.usuario" type="text"
                    v-on:keyup.enter="ValidarUsuario()" />
                  <br />
                </div>
              </div>
              <div class="col-12 row">
                <div class="col-1"><i class="fas fa-key fa-2x"></i></div>
                <div class="col-11">
                  <input class="form-control" placeholder="Contraseña" v-model="current_log.clave" type="password"
                    v-on:keyup.enter="ValidarUsuario()" />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button @click="ValidarUsuario()" class="btn btn-info btn-block btn-lg">
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    UsuariosSelectComponent,
  },
  data() {
    return {
      tarimas: "",
      tarima: "",
      tarima_: "",
      mostrarRefresh: false,
      current: {
        producto: "",
        descripcion: "",
      },
      current_log: {},
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      errors: null,
    };
  },
  mounted() { },
  methods: {
    ValidarUsuario() {
      let self = this;
      DynamicService.postActionList(
        "accounts",
        "usuarios",
        "validar_usuario_clave",
        self.current_log
      )
        .then((response) => {
          self.current_log = {};
          Notifications.toast.success(
            "Hola " + response.data.name,
            "| ¡Qué gusto verte nuevamente!"
          );
          $("#login").modal("hide");
          if (self.current.abrir == "habilitar") {
            $("#habilitarModal").modal("show");
          }
          if (self.current.abrir == "anular") {
            $("#anularModal").modal("show");
          }
        })
        .catch((error) => {
          Notifications.toast.error(
           "¡Oops! " + error.response.data.detail + ".",
            "| Algo salió mal, revisa nuevamente las credenciales ingresadas."
          );
        });
    },
    abrirModalLogin() {
      $("#login").modal("show");
      console.log(this.current.abrir);
      Notifications.toast.success(
        "Necesitamos saber si tienes permisos para esto.",
        "| Por favor, Ingresa tus credenciales."
      );
    },
    select(d) {
      this.tarima = d;
      $("#modalproducto").modal("show");
    },
    buscarTarima(current) {
      let self = this;
      if (
        !current.barra &&
        !current.numero &&
        !current.tipo_traslado &&
        !this.searchtext
      ) {
        self.errors = null;
        self.tarima = "";
        return;
      }
      DynamicService.fetch("wms", "tarima", {
        barra: current.barra,
        numero: current.numero,
        tipo_traslado: current.tipo_traslado,
        "filter[search]": this.$data.searchtext,
      })
        .then((response) => {
          self.tarimas = response.data.results;
          if (!self.tarimas[0]) {
            self.errors = "Tarima no existe";
          } else {
            self.errors = null;
          }
          Notifications.toast.error(":(", self.errors);
        })
        .then((errors) => { });
    },
    resetData() {
      let self = this;
      self.tarimas = "";
      self.tarima = "";
      self.current.numero = "";
      self.current.barra = "";
      self.current.tipo_traslado = "";
      self.errors = null;
      this.searchtext = "";
    },
    abrirTarima(tarima) {
      let self = this;
      DynamicService.postAction("wms", "tarima", tarima.id, "abrir")
        .then((response) => {
          Notifications.alert.success("Habilitar Tarima", "Realizado Correctamente");
          self.resetData();
        })
        .catch((errors) => {
          Notifications.alert.error("Habilitar Tarima", errors.response.data.detail);
          self.resetData();
        });
    },
    anularTarima(tarima) {
      let self = this;
      Notifications.alert.confirm(
        "¿Deseas anular la tarima?",
        "Esta acción es irreversible.",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "tarima",
            tarima.id,
            "anular_tarima_finalizada"
          )
            .then((response) => {
              Notifications.alert.success("Anular Tarima", "Realizado Correctamente");
              self.resetData();
            })
            .catch((errors) => {
              Notifications.alert.error("Anular Tarima", errors.response.data.detail);
              self.resetData();
            });
        }
      );
    },
    reiniciarConteo() {
      let self = this;
      let params = {
        producto_barra: null,
        usuario_solicita: null,
        observaciones: null,
      };
      console.log(self.current);
      if (self.current.producto != null) {
        params.producto_barra = self.current.producto.sku;
      }

      if (self.current.usuario != null) {
        params.usuario_solicita = self.current.usuario.username;
      }

      params.observaciones = self.current.observaciones;

      console.log(params);

      DynamicService.postAction(
        "wms",
        "tarima",
        this.tarima.id,
        "reiniciar_conteo",
        params
      )
        .then((response) => {
          Notifications.alert.success("¡Hecho!", "Se Reinició el Conteo");
          self.resetData();
          $("#modalproducto").modal("hide");
          this.tarima_.producto = "";
        })
        .catch((errors) => {
          console.log(errors.response.data);
          if (!errors.response.data.detail) {
            self.errors = errors.response.data;
            if (errors.response.data.producto_barra) {
              self.errors.producto = errors.response.data.producto_barra;
            }
            if (errors.response.data.usuario_solicita) {
              self.errors.usuario = errors.response.data.usuario_solicita;
            }
          } else {
            self.errors = errors.response.data.detail;
            Notifications.alert.error("Reiniciar Conteo", errors.response.data.detail);
          }
          // this.tarima_.producto = "";
          // $("#modalproducto").modal("hide");
        });
    },
  },
};
</script>
